const filterCategories = ({ apiResponse }) => {
  const {
    categories: { categories }
  } = apiResponse;

  apiResponse.categories.categories = categories
    .filter(category => category.isActive)
    .slice(0, 10);

  return apiResponse;
};

export default filterCategories;
